import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Header } from "../styleguide/atoms/typography/Typography.js";
import Footer from "./Footer.js";
import * as styles from "../styleguide/styles/Stylesheet.js";

const NotFoundPageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-contnet: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media only screen and (max-width: ${styles.width_lg}) {
    height: 100vh;
  }
`;

const NotFoundPageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1 auto;
  flex-direction: column;
`;

const NotFoundText = styled.div`
  color: ${styles.color_accent};
  font-family: ${styles.font_sans};
  font-size: 18px;
  line-height: 1.4;
  text-align: center;
  padding: 0 0 ${styles.spacing_standard};
`;

const HomeLink = styled(Link)`
  text-align: center;
  font-family: ${styles.font_sans};
  font-size: 14px;
  font-weight: ${styles.font_bold};
  color: ${styles.color_accent};
  line-height: 1.4;
  border-radius: 5px;
  padding: 8px 12px;
  text-transform: uppercase;
  border: 2px solid ${styles.color_accent};
  cursor: pointer;
  transition: 250ms all;
  text-decoration: none;

  &:hover {
    color: ${styles.color_white};
    background-color: ${styles.color_accent};
  }
`;

class NotFoundPage extends React.Component {
  render() {
    return (
      <NotFoundPageContainer>
        <NotFoundPageWrapper>
          <Header align="center">404</Header>
          <NotFoundText>Page not found.</NotFoundText>
          <HomeLink to="/">Home</HomeLink>
        </NotFoundPageWrapper>
        <Footer />
      </NotFoundPageContainer>
    );
  }
}

export default NotFoundPage;
